const filterBuilderFieldDefaultOptions = {
    dataField: "name",
    dataType: "string",
    editorOptions: {
        label: "Введите значение",
        startLabel: "Введите значение",
        endLabel: "Введите значение",
        startDateLabel: "Введите значение",
        endDateLabel: "Введите значение",
        labelMode: "floating",
        stylingMode: "outline"
    }
};
export default filterBuilderFieldDefaultOptions;
